import React from 'react';
import _ from "lodash";

import withStyles from "@material-ui/core/styles/withStyles";
import Badge from "@material-ui/core/Badge";
import Popover from "@material-ui/core/Popover";

import styles from "../../styles";
import NotificationItem from "../NotificationItem";
import {getOriginLink} from "../../../../../../utils/constants";
import {shortNumber} from "../../../../utils";


const getItemAttr = (item) => {
  return _.isString(item.path) ? {href: getOriginLink(item.path)} : {onClick: item.path}
}

const DropDownIcon = props => {

  const {
    classes,
    openAction,
    closeAction,
    open,
    faIcon,
    items
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if(open) {
      closeAction()
    } else {
      setAnchorEl(event.currentTarget);
      openAction();
    }
  };

  const handleClose = () => {
    if (open) {
      closeAction();
      setAnchorEl(null);
    }
  };

  const itemsWithValue = React.useMemo(() => items.filter(item => !!item.value), [items])
  const badgeValue = React.useMemo(() => _.sumBy(itemsWithValue, 'value'), [itemsWithValue]);

  return (
    <div className={classes.dropdownMenuWrapper}>
      <NotificationItem faIcon={faIcon} badgeContent={shortNumber(badgeValue)} onClick={handleClick} />
      {badgeValue > 0 && (
        <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
                 classes={{paper: classes.dropdownMenu}}
                 anchorOrigin={{vertical: 55, horizontal: 'right'}}
                 transformOrigin={{vertical: 'top', horizontal: 'right'}}
        >
          {itemsWithValue.map(item => (
            <a key={item.key} className={classes.dropdownItem} {...getItemAttr(item)}>
              {item.name}
              <Badge
                badgeContent={shortNumber(item.value)}
                classes={{
                  root: classes.dropDownItemBadgeRoot,
                  badge: classes.dropDownItemBadge
                }}
              />
            </a>
          ))}
        </Popover>
      )}
    </div>
  );
};

export default withStyles(styles)(DropDownIcon);